import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useAuthService } from '@b2ag/auth'
import { useRouter } from 'vue-router'
import { PAGE_TYPE } from '../page-types'
import { callbacksFromLegalsMicroFrontIframe } from '../../contexts/legals'

/* ------- MICROFRONT - INSCRIPTION ------- */

export const signInRoutes = [
  {
    path: '/registration',
    name: 'register',
    async beforeEnter() {
      const auth = useAuthService()
      await auth.signin()
    },
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      analyticsPageType: PAGE_TYPE.SIGN_UP,
      layout: 'minimal',
    },
  },
  {
    path: '/registration/accept-gcu',
    name: 'accept-cgu-agri',
    component: () => import('@b2ag/micro-front-legals/app'),
    props: () => ({
      microFrontName: 'legals',
      viewName: 'accept-cgu',
    }),
    beforeEnter() {
      const router = useRouter()
      microFrontListener({
        iframe: { href: window.location.origin },
        callbackForMessages: (data: DataForParent) => callbacksFromLegalsMicroFrontIframe(data, router),
        router: router as any,
      })
    },
    meta: {
      inscriptionFlow: true,
      private: true,
      doNotStoreRoute: true,
      layout: 'minimal',
    },
  },

  {
    path: '/registration/link-partner',
    name: 'account-add-cooperative',
    component: () => import('@b2ag/micro-front-signup/app'),
    props: () => {
      return {
        microFrontName: 'signup',
        viewName: 'add-partner',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
        router: useRouter() as any,
      })
    },
    meta: {
      inscriptionFlow: true,
      private: true,
      doNotStoreRoute: true,
      layout: 'minimal',
    },
  },
  {
    path: '/profiles/confirm-association',
    name: 'profile-confirmation',
    component: () => import('@b2ag/micro-front-signup/app'),
    props: () => {
      return {
        microFrontName: 'signup',
        viewName: 'profile-confirmation',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        analyticService: useAnalyticService(),
        router: useRouter() as any,
      })
    },
    meta: {
      inscriptionFlow: true,
      doNotStoreRoute: true,
      analyticsPageType: PAGE_TYPE.PROFILE,
      layout: 'minimal',
    },
  },
]
